import styles from './BannerContentModule.scss';

import cx from 'classnames';
import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';

import { AppType, Link } from 'src/services/cms/typesUtil';
import { ButtonLinkV2 } from '../Button/ButtonLinkV2';
import { Grid } from '../Grid/Grid';
import { TextV2 } from '../TextV2/TextV2';

type BannerContentModuleProps = AppType.Component<{
  headline: string;
  description: string;
  textColor: string;
  backgroundColor: string;
  bannerCta: Link[];
}>;

// Function which returns the entry along with the content type as a flat object
const bannerEntry = (cta?: any, index?: number) => {
  return {
    key: cta._sys?.id || index,
    contentType: cta._sys?.contentType,
    ...cta,
  };
};

export const BannerContentModule: React.FC<BannerContentModuleProps> = ({
  headline,
  description,
  textColor,
  backgroundColor,
  bannerCta,
  ...props
}) => {
  const [inViewAnimation, setInViewAnimation] = useState(false);

  return (
    <Grid container className={styles.bannerComponent} {...props._attributes} style={{ backgroundColor, color: textColor }} justifyContent="center">
      <Grid item xs={12} md={9} lg={8}>
        <InView onChange={setInViewAnimation}>
          <TextV2
            className={cx(styles.bannerComponentTitle, { [styles.bannerComponentTitleAnimation]: inViewAnimation })}
            tagName="h2"
            variant="h2-bold"
            value={headline}
          />
        </InView>
        <TextV2
          value={description}
          variant="h3-bold"
          tagName="h3"
          isMarkdown
          className={styles.bannerComponentDescription}
        />
        {bannerCta && bannerCta.length > 0 && (
          <Grid container className={styles.bannerComponentCtaContainer} justifyContent="center">
            {bannerCta.map((cta, index) => (
              <ButtonLinkV2
                entry={bannerEntry(cta)}
                key={bannerEntry(cta, index).key}
                className={styles.bannerComponentCtaContainerButton}
              />
            ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
